<template>
  <div class="sidenavright-menu fullheight">
    <div class="sidenavright-content">
        <div class="pill-header">
          <div class="row no-margin">
            <div class="col no-padding">
              <div class="pill-title">
                {{ invoiceDetail.invoice_number }}
              </div>
            </div>
            <div class="col-md-auto no-padding bgclose">
              <div class="close-sidebar">
                <svgicon name="cancelwhite" width="14" height="14"
                :original="true" @click="closeMenu" />
              </div>
            </div>
          </div>
        </div>
        <div class="pill-body">
        <div class="pill-row tabsection">
        <Tabs>
          <Tab v-if="customFields.length" :title="$t('DETAILS_SLIDER')" :active="!!customFields.length">
            <div v-if = "invoiceDetail.status === this.invoiceStatusPaid" class="pb-10">
              <div v-if= invoiceDetail.utr_number class = "d-flex align-item-center justify-content-between my-10">
              <div class = "text-sm text-grey-dark text-fw-n"> UTR Number : </div>
              <div class = "text-sm text-grey-dark text-bold"> {{ invoiceDetail.utr_number }}</div>
            </div>
            <div v-if= invoiceDetail.payment_paid_ref_no class = "d-flex align-item-center justify-content-between my-10">
              <div class = "text-sm text-grey-dark text-fw-n"> ERP Document Number : </div>
              <div class = "text-sm text-grey-dark text-bold"> {{ invoiceDetail.payment_paid_ref_no }}</div>
            </div>
            <div v-if = invoiceDetail.payment_time class = "d-flex align-item-center justify-content-between my-10">
              <div class="text-sm text-grey-dark text-fw-n">Payment Processing Date & Time :</div>
              <div class="text-sm text-grey-dark text-bold">
                {{ formattedPaymentTime }}
              </div>
              </div>
            <div v-if = invoiceDetail.tds_deduction class = "d-flex align-item-center justify-content-between my-10">
              <div class = "text-sm text-grey-dark text-fw-n"> TDS Deduction :</div>
              <div class = "text-sm text-grey-dark text-bold"> {{ invoiceDetail.tds_deduction }}</div>
            </div>
            <div v-if = invoiceDetail.freight_amount_paid class = "d-flex align-item-center justify-content-between my-10">
              <div class = "text-sm text-grey-dark text-fw-n"> Freight Amount Paid : </div>
              <div class = "text-sm text-grey-dark text-bold"> {{ invoiceDetail.freight_amount_paid}} </div>
            </div>
            </div>
            <div v-if = invoiceDetail.partial_amount_paid class = "d-flex align-item-center justify-content-between my-10">
              <div class = "text-sm text-grey-dark text-fw-n"> {{ $t('Partial_Amount_Paid') }} : </div>
              <div class = "text-sm text-grey-dark text-bold"> {{ invoiceDetail.partial_amount_paid}} </div>
            </div>
            <Form :inline="true" class="form-default mb-20"
              v-for="(field, index) in customFields" :key="index">
               <FormItem
                v-if="field.type === 'boolean'"
                :label="field.fieldName"
                :required="field.required"
                class="form-switch-item"
                :class="{'is-error' :((field.value === null || field.value === '')
                  && field.required)}">
                <h5 class="switchitem">
                  <SwitchBtn
                    v-model="field.value"
                    :disabled="true"
                    :label="field.fieldName"
                    size="small"
                    active-text="YES"
                    inactive-text="NO"
                    active-value="YES"
                    inactive-value="NO"
                    class="default-switch">
                  </SwitchBtn>
                </h5>
              </FormItem>
              <FormItem :label="field.fieldName" v-else-if="field.type === 'text'">
               <Input
                  size="mini"
                  type="text"
                  :disabled="true"
                  v-model="field.value">
                </Input>
              </FormItem>
              <FormItem :label="field.fieldName" v-else-if="field.type === 'number'">
                <Input
                  size="mini"
                  type="text"
                  :disabled="true"
                  :has-error="field.value === null"
                  v-model="field.value">
                </Input>
              </FormItem>
              <FormItem :label="field.fieldName" v-else-if="field.type === 'date'">
                <DatePicker
                  v-model="field.value"
                  type="datetime"
                  :disabled="true"
                  :clearable="true"
                  format="dd-MM-yyyy hh:mmA"
                  size="small"
                />
              </FormItem>
            </Form>
          </Tab>
          <Tab :title="$t('REMARKS')" :active="!customFields.length">
            <div class="cardbox" v-if="showAttachment">
              <div class="labelpanel text-sm"><strong>{{invoiceAttachText}}</strong></div>
              <Attachments
                :attachments="invoiceAttach"
                :showPreview="true"
                :maxAllowed=10
                :multiple=true
                :allowDelete="allowAttachmentDelete"
                :disableUpload="disableUpload"
                :allowedFileFormats="allowedFileFormats"
                :invoiceAttach="true"
                @addAttachments="addAttachments"
                @removeAttachments="showDialog" />
            </div>
            <div class="cardbox" v-if="showCnAttachments">
              <div class="labelpanel text-sm"><strong>{{ $t('CREDIT_NOTE_ATTACH') }}</strong></div>
              <Attachments
                :attachments="cnAttachments"
                :showPreview="true"
                :maxAllowed="cnDnAttachmentLimit"
                :multiple=true
                :invoiceAttach="true"
                :allowDelete="!isInvoiceApproved"
                :disableUpload="disableCnUpload"
                :allowedFileFormats="allowedFileFormats"
                @addAttachments="addAttachments($event, attachmentParentType.CREDIT_NOTE)"
                @removeAttachments="removeAttachments($event, attachmentParentType.CREDIT_NOTE)" />
            </div>
            <div class="cardbox" v-if="showDnAttachments">
              <div class="labelpanel text-sm"><strong>{{ $t('DEBIT_NOTE_ATTACH') }}</strong></div>
              <Attachments
                :attachments="dnAttachments"
                :showPreview="true"
                :maxAllowed="cnDnAttachmentLimit"
                :multiple=true
                :invoiceAttach="true"
                :allowDelete="!isInvoiceApproved"
                :disableUpload="disableDnUpload"
                :allowedFileFormats="allowedFileFormats"
                @addAttachments="addAttachments($event, attachmentParentType.DEBIT_NOTE)"
                @removeAttachments="removeAttachments($event, attachmentParentType.DEBIT_NOTE)" />
            </div>
            <div class="tab-body" v-if="invoiceDetail">
              <PrimaryComments
                :comments="invoiceDetail.comments"
                :invoiceId="invoiceDetail.id"
                v-on:addComment = "addComment"/>
              </div>
            <div>
            </div>
          </Tab>
          <Tab :title="$t('TIMELINE')" v-if="showTimeline">
            <div class="block timelineblock">
              <Timelineblock
              :timelineEvents="invoiceDetail.timelines"
              />
            </div>
          </Tab>
          <!-- <Tab title="AI Agent Actions">
            <AIAgentActions
              :invoiceId="invoiceDetail.id"
              :isInvoice="true"
            />
          </Tab> -->
        </Tabs>
      </div>
      <Dialog
        width="400px"
        middle="true"
        :center="false"
        title="Confirmation"
        :append-to-body="true"
        class="default-dialog"
        :visible.sync="dialogVisible">
        <div class="dialog-content">
          {{ $t('DELETE_ATTACHMENT_PROMPT') }}<br>
          This action CANNOT be reversed.
        </div>
        <span slot="footer" class="dialog-footer">
          <Button type="text" class="button-link" size="mini" @click="dialogVisible=false">NO</Button>
          <Button type="primary" size="mini" @click="removeAttachments(deleteAttachment)">YES</Button>
        </span>
      </Dialog>
    </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import PrimaryComments from '@common/components/PrimaryComments';
import Attachments from '@common/components/Attachments';
import AttachmentsPopup from '@common/components/AttachmentsPopup';
import Timelineblock from '@common/components/Timelineblock';
import { attachmentParentType } from 'pando-constants';
import { isInvoiceSignatureEnabled } from '@common/lib/payments';
import { status } from '@/constants/payments';
import { mapGetters } from 'vuex';
import { formatDetailedCommentDate } from '../../../../../cha/src/lib/Date';
import AIAgentActions from '../../../../../common-v2/components/AIAgentActions';

const INVOICE_STATUS_PAID = 7;
export default {
  props: {
    invoiceDetail: {
      type: Object,
      required: true,
    },
  },
  components: {
    PrimaryComments,
    Timelineblock,
    Attachments,
    AttachmentsPopup,
    AIAgentActions,
  },
  data() {
    return {
      invoiceAttach: [],
      cnAttachments: [],
      dnAttachments: [],
      disableUpload: false,
      validStatuses: [1001, 1003, 1007],
      allowedFileFormats: ['pdf', 'jpeg', 'png', 'jpg'],
      attachmentType: null,
      dialogVisible: false,
      deleteAttachment: null,
      canDeleteAttachment: false,
      fileUploadCount: 0,
      invoiceStatusPaid: INVOICE_STATUS_PAID,
      attachmentParentType,
    };
  },
  created() {
    if (this.invoiceDetail) {
      if (this.invoiceDetail.attachment) {
        this.invoiceAttach = this.invoiceDetail.attachment;
      }
      if (this.invoiceDetail.credit_note_attachments) {
        this.cnAttachments = this.invoiceDetail.credit_note_attachments;
      }
      if (this.invoiceDetail.debit_note_attachments) {
        this.dnAttachments = this.invoiceDetail.debit_note_attachments;
      }
    }
    this.customFields = this.invoiceDetail.custom_fields;
    this.fileUploadCount = this.invoiceDetail.attachment.length;
    if (this.invoiceDetail.attachment && this.invoiceDetail.attachment.length < 10
      && this.invoiceDetail.status === 1) {
      this.disableUpload = false;
    } else {
      this.disableUpload = this.invoiceDetail.attachment.length >= 10;
    }
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
    showCnAttachments() {
      return !this.isInvoiceApproved || !!this.cnAttachments.length;
    },
    showDnAttachments() {
      return !this.isInvoiceApproved || !!this.dnAttachments.length;
    },
    isInvoiceApproved() {
      return !!this.invoiceDetail.approved_at;
    },
    isValidStatus() {
      const id = this.invoiceDetail.status;
      const invoiceStatus = status.find(i => i.ids && i.ids.includes(id));
      this.validStatuses.push(11); // Custom status
      return this.validStatuses.includes(invoiceStatus && invoiceStatus.groupId);
    },
    allowAttachmentDelete() {
      if (this.invoiceSignatureEnabled) {
        this.canDeleteAttachment =
          (this.invoiceDetail.invoice_signature_status === 'TRANSPORTER_UPLOADED_DIGITAL_SIGNATURE');
      }
      return this.isValidStatus;
    },
    showAttachment() {
      return this.isValidStatus || this.invoiceDetail.is_digital_invoice_enabled || this.invoiceDetail.attachment.length;
    },
    invoiceSignatureEnabled() {
      return isInvoiceSignatureEnabled(this.currentClientConfig);
    },
    invoiceAttachText() {
      if (this.invoiceSignatureEnabled) {
        this.attachmentType = attachmentParentType.DIGITALLY_SIGNED_INVOICE;
        return this.$t('DIGITALLY_SIGNED_INVOICE');
      }
      this.attachmentType = attachmentParentType.THIRD_PARTY_INVOICE;
      return this.$t('INVOICE_ATTACHMENT');
    },
    showTimeline() {
      return this.invoiceDetail && this.invoiceDetail.timelines
        && this.invoiceDetail.timelines.length;
    },
    formattedPaymentTime() {
      return this.getTimeStamp(this.invoiceDetail.payment_time);
    },
    cnDnAttachmentLimit() {
      return (this.currentClientConfig.payment_settings
      && this.currentClientConfig.payment_settings.cn_dn_attachment_limit) || 10;
      // default 10
    },
    disableCnUpload() {
      return (this.cnAttachments.length >= this.cnDnAttachmentLimit)
        || this.isInvoiceApproved;
    },
    disableDnUpload() {
      return (this.dnAttachments.length >= this.cnDnAttachmentLimit)
        || this.isInvoiceApproved;
    },
  },
  methods: {
    closeMenu() {
      this.$emit('close');
    },
    async addComment(comment) {
      try {
        const result = await this.$store.dispatch('paymentsV2/addInvoiceComment', {
          invoiceId: this.invoiceDetail.id,
          message: comment,
        });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('COMMENT_ADD_FAILURE') });
          return;
        }
        this.invoiceDetail.comments.push(result);
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('COMMENT_ADD_FAILURE') });
      }
    },
    setLocalAttachments(attachment, attachmentType) {
      if (attachmentType === this.attachmentParentType.CREDIT_NOTE) {
        this.cnAttachments.push(attachment);
      } else if (attachmentType === this.attachmentParentType.DEBIT_NOTE) {
        this.dnAttachments.push(attachment);
      } else {
        this.fileUploadCount += 1;
        this.invoiceAttach.push(attachment);
      }
    },
    async addAttachments(file, attachmentType = this.attachmentType) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        formData.append('parent_id', this.invoiceDetail.id);
        formData.append('parent_type', attachmentType);
        const result = await this.$store.dispatch('paymentsV2/addInvoiceAttachment', formData);
        if (result && result.error) {
          this.$error({ message: result.error || this.$getErr('UPLOAD_FAILS') });
        } else if (result && result.data) {
          const attachment = {
            name: result.data.content_file_name,
            url: result.data.metadata.location,
            id: result.data.id,
          };
          this.setLocalAttachments(attachment, attachmentType);
          if (this.invoiceSignatureEnabled) {
            await this.updateSignatureStatus('TRANSPORTER_UPLOADED_DIGITAL_SIGNATURE');
            this.canDeleteAttachment = true;
          }
        } else {
          this.$error({ message: this.$getErr('UPLOAD_FAILS') });
        }
        if (this.fileUploadCount >= 10) {
          this.disableUpload = true;
        }
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$error({ message: apiError || this.$getErr('UPLOAD_FAILS') });
      }
    },
    async updateSignatureStatus(_status = null) {
      await this.$store.commit('paymentsV2/updateSignatureStatus', {
        invoiceId: this.invoiceDetail.id,
        status: _status,
      });
    },
    async showDialog(file) {
      if (isInvoiceSignatureEnabled(this.currentClientConfig)) {
        this.dialogVisible = true;
        this.deleteAttachment = file;
      } else {
        await this.removeAttachments(file);
      }
    },
    async removeAttachmentPostProcess(file, attachmentType) {
      if (attachmentType === attachmentParentType.CREDIT_NOTE) {
        this.cnAttachments = this.cnAttachments.filter(attach => attach.id !== file.id);
      } else if (attachmentType === attachmentParentType.DEBIT_NOTE) {
        this.dnAttachments = this.dnAttachments.filter(attach => attach.id !== file.id);
      } else {
        this.invoiceAttach = this.invoiceAttach.filter(attach => attach.id !== file.id);
        this.fileUploadCount -= 1;
        this.disableUpload = false;
        if (this.invoiceSignatureEnabled && (this.fileUploadCount < 1)) {
          await this.updateSignatureStatus();
        }
        if (this.fileUploadCount >= 10) {
          this.disableUpload = true;
        }
      }
    },
    async removeAttachments(file, attachmentType = this.attachmentType) {
      try {
        if (file) {
          let attachLength = 0;
          if (attachmentType === attachmentParentType.CREDIT_NOTE) {
            attachLength = this.cnAttachments.length - 1;
          } else if (attachmentType === attachmentParentType.DEBIT_NOTE) {
            attachLength = this.dnAttachments.length - 1;
          } else {
            attachLength = this.fileUploadCount - 1;
          }
          const result = await this.$store.dispatch('paymentsV2/deletInvoiceAttachment', { attachmentId: file.id, attachLength });
          if (result && result.error) {
            this.$error({ message: this.$getErr('DELETE_FILE_FAILS') });
            return;
          }
          await this.removeAttachmentPostProcess(file, attachmentType);
        }
      } catch (error) {
        this.$error({ message: this.$getErr('DELETE_FILE_FAILS') });
      } finally {
        this.dialogVisible = false;
      }
    },
    getTimeStamp(time) {
      return formatDetailedCommentDate(time);
    },
  },
};
</script>
